import {Component} from '@angular/core';
import MenuTogglerService from "../../services/menuToggler.service";

@Component({
    selector: 'home',
    template: require('./home.component.html'),
    styles: [String(require('./home.styl'))]
})

export class HomeComponent {
    private toggle;

    constructor(private toggler: MenuTogglerService) {
        this.toggle = () => {
            this.toggler.toggleLeftMenu();
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/components/home/home.component.ts